import { ContentItem } from 'kentico-cloud-delivery';

import get from 'lodash/get';

export default class ContactLink extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get name() {
    return get(this, '_name.value', '');
  }

  get url() {
    return get(this, '_url.value', '');
  }

  get id() {
    return get(this, 'system.id', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/ContactLink.model.js